export default __webpack_public_path__ + "static/media/faq-product-table1-cn.37daa44b.webp";